import { TRIGGER_AGENT_TYPE } from '../../../actions/doctorsPi/agent';
import { COLLECT_LOGIN_DETAILS } from '../../../actions/doctorsPi/auth';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/doctorsPi/payloadCollection';
import {
    CHECK_PAYMENTS_STATUS,
    SEND_STK_TAGGING_INFO,
    TRIGGER_CONFIRM_ORDER,
    TRIGGER_KE_PAYMENTS_STK_PUSH,
    TRIGGER_PAYMENTS_STK_PUSH,
} from '../../../actions/doctorsPi/payments';
import { COLLECT_PERSONAL_DETAILS_DATA } from '../../../actions/doctorsPi/personalDetails';
import { COLLECT_DOCTORS_PI_QUOTE_FORM_DATA, COLLECT_SHARE_QUOTE_FORM_DATA } from '../../../actions/doctorsPi/quote';
import { getAgentsService } from './agents';
import { loginService } from './login';
import { orderConfirmationService } from './orderConfirmation';
import { payloadSubmitService } from './payloadCollection';
import { paymentService, paymentsStkService, paymentsStkStatusService } from './payments';
import { premiumCalculationService } from './quote';
import { shareQuoteService } from './shareQuote';
import { payloadPersonalDetailsService } from './personalDetails';
import { payloadUploadDeclarationsService, payloadUploadDocumentsService } from './uploadDocuments';
import {
    INITIATE_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
    PAYSTACK_SUBMIT_PAYMENT,
} from '../../../actions/doctorsPi/paystack';
import { paystackPaymentService, paystackStkStatusService, submitPaymentService } from './paystack';
import { UPLOAD_DECLARATIONS_DATA, UPLOAD_DOCUMENTS_DATA } from '../../../actions/doctorsPi/documents';

export const doctorsPiCover = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_KE_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_DOCTORS_PI_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_AGENT_TYPE)) {
        return getAgentsService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PERSONAL_DETAILS_DATA)) {
        return payloadPersonalDetailsService(store, next, action);
    }

    if (action.type.startsWith(UPLOAD_DECLARATIONS_DATA)) {
        return payloadUploadDeclarationsService(store, next, action);
    }

    if (action.type.startsWith(UPLOAD_DOCUMENTS_DATA)) {
        return payloadUploadDocumentsService(store, next, action);
    }

    if (action.type.startsWith(SEND_STK_TAGGING_INFO)) {
        return paymentService(store, next, action);
    }

    return null;
};
